export default __webpack_public_path__ + "static/media/Bandeau 15.0ffa19ea.jpg";